import { ReactElement } from 'react';
import { createSlot } from '@radix-ui/react-slot';

import css from './styles.module.css';

const IconSlot = createSlot('EmptyState.Icon');

export interface EmptyStateIconProps {
  children?: ReactElement<{ className?: string }>;
}

/**
 * A decorative icon, rendered above the title. Expects a single element child,
 * which it styles in place rather than wrapping.
 */
export function EmptyStateIcon({ children }: EmptyStateIconProps) {
  return (
    <IconSlot className={css.icon} aria-hidden>
      {children}
    </IconSlot>
  );
}
